import { isMobile } from 'mobile-device-detect';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useAdsContext } from '../contexts/AdsContext';
import { useTargeting } from './useTargeting';
const useLoadAd = (slotConfig) => {
    const { adsEnabled, gptReady } = useAdsContext();
    const gslot = useRef(null);
    const [adHasLoaded, setAdHasLoaded] = useState(false);
    const targeting = useTargeting({ slotConfig });
    const applyStylesToIframe = useCallback(() => {
        const adElement = document.getElementById(slotConfig.id);
        if (adElement) {
            const iframe = adElement.querySelector('iframe');
            if (iframe) {
                iframe.style.height = isMobile ? `${slotConfig.placeholderHeightMobile}px` : `${slotConfig.placeholderHeight}px`;
                iframe.style.maxWidth = '100%';
                iframe.style.width = '100%';
                iframe.width = '100%';
                iframe.height = isMobile ? `${slotConfig.placeholderHeightMobile}px` : `${slotConfig.placeholderHeight}px`;
            }
        }
    }, []);
    const updateTargeting = useCallback(() => {
        if (!gslot.current) {
            return;
        }
        targeting.forEach((item) => {
            if ('key' in item && 'value' in item && item.value)
                gslot.current?.setTargeting(item.key, item.value.toString());
        });
    }, [targeting]);
    const loadAd = useCallback(() => {
        window.googletag.cmd.push(() => {
            gslot.current = window.googletag.defineSlot(slotConfig.slotId, slotConfig.sizes, slotConfig.id);
            if (gslot.current) {
                gslot.current.addService(window.googletag.pubads().addEventListener('slotOnload', (ev) => {
                    if (ev.slot === gslot.current) {
                        applyStylesToIframe();
                        setAdHasLoaded(true);
                    }
                }));
                updateTargeting();
                window.googletag.enableServices();
                window.googletag.display(slotConfig.id);
            }
        });
    }, [updateTargeting]);
    useEffect(() => {
        if (!gptReady || !adsEnabled || !slotConfig)
            return;
        loadAd();
    }, [gptReady, adsEnabled]);
    useEffect(() => {
        if (!gslot.current)
            return;
        window.googletag.cmd.push(() => {
            updateTargeting();
            window.googletag.pubads().refresh([gslot.current]);
        });
    }, [updateTargeting]);
    useEffect(() => () => {
        if (!gslot.current)
            return;
        window.googletag.cmd.push(() => {
            window.googletag.destroySlots([gslot.current]);
            gslot.current = null;
        });
    }, []);
    return adHasLoaded;
};
export default useLoadAd;
